import React from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import Model1Form from "../Model1Form";
import {useCreateModel1} from "../query";
import MDBox from "materialDashboard/components/MDBox";


const Model1Create = () => {
    const {t} = useTranslation(['models1', 'validation', 'enums']);
    const navigate = useNavigate();
    const createModel1 = useCreateModel1();

    const handleSubmit = async (data) => {
        await createModel1.mutateAsync(data);
        await navigate('/models1');
    }

    return <MDBox sx={{mx: 2}}>
        <Model1Form title={t('model1Create.title')}
                    onSubmit={handleSubmit}/>
    </MDBox>
}

export default Model1Create;